document.addEventListener("DOMContentLoaded", function(){

const copyBtn = document.querySelector(".nse-copy-link");

if(copyBtn){
copyBtn.addEventListener("click", function(){

const url = this.dataset.url;

navigator.clipboard.writeText(url);

this.innerHTML = "✓";

setTimeout(()=>{
this.innerHTML = "🔗";
},1500);

});
}

const nativeShare = document.querySelector(".nse-native-share");

if(nativeShare && navigator.share){

nativeShare.addEventListener("click", () => {

navigator.share({
title: document.title,
url: window.location.href
});

});

}

});